import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import NotificationToast from "./NotificationToast";

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        // 👇 Choix dynamique de l’URL WebSocket
        const SOCKET_URL =
            window.location.hostname === "localhost"
                ? process.env.REACT_APP_BACKEND_URL_SOCKET_LOCAL
                : process.env.REACT_APP_BACKEND_URL_SOCKET_PROD;

        const newSocket = io(SOCKET_URL, {
            transports: ["websocket"], // ← optionnel, pour forcer WebSocket
        });
        setSocket(newSocket);

        newSocket.on("nouvelUtilisateur", (data) => {
            setNotifications((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "user",
                    message: `🆕 Nouvel utilisateur : ${data.nom} (${data.role})`,
                },
            ]);
        });

        newSocket.on("nouveauProspect", (data) => {
            setNotifications((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "prospect",
                    message: `👤 Nouveau prospect : ${data.nom} (${data.entreprise})`,
                },
            ]);
        });

        return () => newSocket.disconnect();
    }, []);

    return (
        <SocketContext.Provider value={{ socket, notifications, setNotifications }}>
            {children}
            <div className="fixed top-5 right-5 space-y-4 z-50">
                {notifications.map((notif) => (
                    <NotificationToast key={notif.id} notif={notif} />
                ))}
            </div>
        </SocketContext.Provider>
    );
};
